import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Spin } from 'antd'
import { useAuthStore } from '@/stores/authStore'
import { authApi } from '@/services/api'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, token, setLoading, isLoading, logout } = useAuthStore()
  const location = useLocation()

  window.logger?.info('ProtectedRoute rendered', {
    isAuthenticated,
    hasToken: !!token,
    isLoading,
    currentPath: location.pathname,
    search: location.search,
    state: location.state
  })

  useEffect(() => {
    const verifyToken = async () => {
      if (token && !isAuthenticated) {
        try {
          window.logger?.info('Verifying token...')
          setLoading(true)
          await authApi.verifyToken()
          window.logger?.info('Token verification successful')
          // Token有效，保持登录状态
        } catch (error) {
          window.logger?.error('Token verification failed', error)
          // Token无效，清除状态
          logout()
        } finally {
          setLoading(false)
        }
      }
    }

    verifyToken()
  }, [token, isAuthenticated, setLoading, logout])

  if (isLoading) {
    window.logger?.info('Showing loading spinner for token verification')
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column'
      }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>验证登录状态...</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    window.logger?.info('User not authenticated, redirecting to login', {
      from: location.pathname
    })
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  window.logger?.info('User authenticated, rendering protected content')
  return <>{children}</>
}

export default ProtectedRoute
